// extracted by mini-css-extract-plugin
export default {"inner":"zBnx5","main":"Cz51U","actions":"Gc4pV","action":"O0XnP"};